<script setup lang="ts">
/**
 * `SystemOverlayHost.vue` — global mount point for connectivity
 * overlays.
 *
 * Connectivity overlays are temporarily disabled while the web port's
 * realtime event endpoint is still being stabilized. Keep this host mounted so
 * the overlays can be re-enabled without touching `App.vue`.
 *
 * Mounted once in `App.vue` so the overlay sits above every route.
 */
defineOptions({ name: "SystemOverlayHost" });
</script>

<template>
  <div class="cf-system-overlays-disabled" aria-hidden="true" />
</template>

<style scoped>
.cf-system-overlays-disabled {
  display: none;
}
</style>
